import { IDiscountRepository } from '../domain/IDiscountRepository'

export class UploadMetaDiscountAssociations {
  constructor(private readonly discountRepository: IDiscountRepository) {}

  async execute(discountId: string, associationsFile: File): Promise<void> {
    return this.discountRepository.uploadMetaDiscountAssociations(discountId, associationsFile)
  }
}
